export default __webpack_public_path__ + "static/media/logo.d9b1938f.png";